import React from "react";

import { useLanguage, useTranslation } from "utils";

import { ErrorBoundary, Flex, Layout, LazyLoadImage, MainPage, SelectLanguage, Svg } from "components";

const { Header } = Layout;

export const MaintenancePage = () => {
  const { t } = useTranslation("global");
  useLanguage();

  return (
    <MainPage pageName="maintenance" className="page">
      <section className="page">
        <Header className="" style={{ background: "none", margin: "3rem" }}>
          <Flex align="center" justify="space-between">
            <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
            <ErrorBoundary>
              <SelectLanguage placement="bottomRight" skipRefresh={false} />
            </ErrorBoundary>
          </Flex>
        </Header>
      </section>
      <Flex align="center" justify="center" gap="3rem" vertical style={{ height: "100%" }}>
        <h1 className="hero">{t("maintenance.title")}</h1>
        <p className="paragraph-xl">{t("maintenance.message")}</p>
        <div style={{ width: "50%", height: "50%" }}>
          <LazyLoadImage alt="hello" className="hero-image" src="/images/homepage/homepage_video.jpg" />
        </div>
      </Flex>
    </MainPage>
  );
};
